'use strict'
const utils = require('./helpers/utils')
const constants = require('./helpers/imageServiceConstants')
const imageServiceUtils = require('./helpers/imageServiceUtils')
const transformParts = require('./helpers/imageTransformParts')
const transformOptions = require('./helpers/imageTransformOptions')
const transforms = require('./engines/transforms')
const attributes = require('./engines/attributes')

/**
 * returns image transform uri and the
 * needed css for alignment and positioning
 * @param {string}                  fittingType         imageServicesTypes.fittingTypes
 * @param {ImageTransformSource}    src                 source image
 * @param {ImageTransformTarget}    target              target component
 * @param {ImageTransformOptions}   options           transform options
 *
 * @returns {{uri: string, css: {img: {}, container: {}}} | {uri: string, attr: {img: {}, container: {}}} | {}}
 */
function getData(fittingType, src, target, options) {
    let data = {}
    const fileType = imageServiceUtils.getFileType(src.id),
        fileName = imageServiceUtils.getFileName(src.id),
        fileExtension = imageServiceUtils.getFileExtension(src.id),
        isWEBPSupport = imageServiceUtils.isWEBPBrowserSupport(fileType)

    const transformsObj = {
        fileName,
        fileExtension,
        fileType,
        isWEBPSupport,
        fittingType,
        src: {
            id: src.id,
            width: src.width,
            height: src.height,
            isCropped: false
        },
        quality: 0,
        progressive: true,
        unsharpMask: {},
        parts: []
    }

    // check if valid request
    if (imageServiceUtils.isValidRequest(fittingType, src, target)) {
        // check if image transformation is applicable (e.g. .gif, .wix_mp)
        if (imageServiceUtils.isImageTransformApplicable(src.id)) {
            transformParts.setTransformParts(transformsObj, src, target)
            transformOptions.setTransformOptions(transformsObj, options)

            // set the uri property
            data.uri = transforms.getImageURI(transformsObj)
        } else {
            data.uri = src.id
        }

        //set the CSS or the SVG property
        utils.assign(data, attributes.getAttributes(transformsObj, target))
    } else {
        // empty data
        data = constants.emptyData
    }

    // return data to be used in html
    return data
}

module.exports = {
    populateGlobalFeatureSupport: imageServiceUtils.populateGlobalFeatureSupport,
    getData,
    fittingTypes: constants.fittingTypes,
    alignTypes: constants.alignTypes,
    htmlTag: constants.htmlTag
}



// WEBPACK FOOTER //
// ./src/imageClientApi/src/main/imageClientApi.js